import request from '@/utils/http.js';

/**
 * 检查报名表单是否开启独立链接以及独立链接是否有效
 * */
function fetchShortLink(params = {}) {
  const url = '/get/link';
  return request({
    url: url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: params
  });
}

export default {
  fetchShortLink
};
